import { render } from "./forgetPassword.vue?vue&type=template&id=78caa6da&scoped=true"
import script from "./forgetPassword.vue?vue&type=script&lang=js"
export * from "./forgetPassword.vue?vue&type=script&lang=js"

import "./forgetPassword.vue?vue&type=style&index=0&id=78caa6da&lang=scss&scoped=true"

import exportComponent from "E:\\项目\\经济运行\\econo-eco-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78caa6da"]])

export default __exports__